import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { House, MagnifyingGlass, ArrowLeft } from '@phosphor-icons/react';
import { Button } from '../components/ui/button';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#F8F6FF] flex items-center justify-center p-6">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center max-w-lg"
      >
        {/* 404 Illustration */}
        <div className="relative mb-8">
          <div className="text-[150px] sm:text-[200px] font-bold text-[#EDE9FE] font-['Outfit'] leading-none select-none">
            404
          </div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-24 h-24 rounded-full bg-gradient-to-br from-[#5B21B6] to-[#8B5CF6] flex items-center justify-center shadow-lg">
              <MagnifyingGlass className="w-12 h-12 text-white" weight="duotone" />
            </div>
          </div>
        </div>
        
        <h1 className="text-3xl sm:text-4xl font-bold text-[#1E1B4B] font-['Outfit'] mb-4">
          Page Not Found
        </h1>
        
        <p className="text-[#6B7280] text-lg mb-8">
          Oops! The page you're looking for doesn't exist or has been moved. 
          Let's get you back on track.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/">
            <Button className="bg-[#5B21B6] hover:bg-[#4C1D95] rounded-full px-8 h-12 w-full sm:w-auto">
              <House className="w-5 h-5 mr-2" weight="duotone" />
              Back to Home
            </Button>
          </Link>
          <Button 
            variant="outline" 
            onClick={() => window.history.back()}
            className="rounded-full px-8 h-12 border-2 border-[#5B21B6] text-[#5B21B6] hover:bg-[#EDE9FE]"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Go Back
          </Button>
        </div>
        
        {/* Quick Links */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <p className="text-sm text-[#6B7280] mb-4">Or check out these pages:</p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/about" className="text-[#5B21B6] hover:underline font-medium">About</Link>
            <Link to="/faq" className="text-[#5B21B6] hover:underline font-medium">FAQ</Link>
            <Link to="/contact" className="text-[#5B21B6] hover:underline font-medium">Contact</Link>
            <Link to="/login" className="text-[#5B21B6] hover:underline font-medium">Sign In</Link>
          </div>
        </div>
      </motion.div>
    </div>
  );
}
